<h1>Scripts</h1>

<div class="mat-button-group mb-3"  *xuiPermissionRequired="'Clinical.CustomScripts.Write'; condition: !loading">
  <button mat-flat-button color="primary"  (click)="CreateCustomScript()">Create Acute Script</button>
</div>

@if (loading) {
  <xui-loading-spinner></xui-loading-spinner>
}

<div class="mat-card-list" *xuiPermissionRequired="'Clinical.Scripts.Read'; condition: !loading">
  @for (script of scripts(); track script.id) {
    <mat-card class="compact">
      <app-script-widget [script]="script" ></app-script-widget>
    </mat-card>
  }


  @if (!hasScripts) {
    <mat-card>
      <mat-card-content>
        <span>No scripts have been printed for this patient.</span>
      </mat-card-content>
    </mat-card>
  }
</div>
